module.exports = "/assets/site/images/partner.png?5d6ef40e80340005daacc3dd779a78b8";